module.exports = __webpack_public_path__ + "static/media/JetMinds.01550704.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/JetMinds.gif
// module id = 789
// module chunks = 20